const determineLatestOrgId = (orgsFromIdentity, userInfo) => {
  const userIsNotAssociatedWithAnyOrgs = Array.isArray(orgsFromIdentity) && orgsFromIdentity.length === 0;
  const userIsAssociatedWithOrgs = Array.isArray(orgsFromIdentity) && orgsFromIdentity.length;
  const defaultOrgs = Array.isArray(orgsFromIdentity) && orgsFromIdentity.filter(org => org.isDefault);
  const cachedDefaultOrg =
    Array.isArray(orgsFromIdentity) && orgsFromIdentity.find(org => org.id === userInfo.organisationId);
  const hasDefaultOrgs = defaultOrgs.length;

  let latestOrgId;

  if (cachedDefaultOrg) {
    latestOrgId = cachedDefaultOrg.id;
  } else if (userIsNotAssociatedWithAnyOrgs) {
    latestOrgId = null;
  } else if (hasDefaultOrgs) {
    latestOrgId = defaultOrgs[0].id;
  } else if (userIsAssociatedWithOrgs) {
    // handle bugs where no default is set, just use the first org (see: EPS-9337)
    latestOrgId = orgsFromIdentity[0].id;
  } else {
    console.warn('If this happens, something is very broken with orgs');
    latestOrgId = null;
  }

  return latestOrgId;
};

function tokenIsTerminated(token) {
  return token === 'terminated' || token === 'no-session-found';
}

module.exports = { determineLatestOrgId, tokenIsTerminated };
